/** Consistent initials for avatars (headers, PM, comments). */
export function getUserInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return name.trim().substring(0, 2).toUpperCase() || '?';
}

export const AVATAR_BG_COLORS = ['#2C3E2F', '#4A6FA5', '#8B5CF6', '#D97706', '#DC2626', '#0891B2'];

export function getAvatarBgColor(id: string): string {
  const key = id || '?';
  return AVATAR_BG_COLORS[key.charCodeAt(0) % AVATAR_BG_COLORS.length];
}
